import { Box } from '@chakra-ui/react'

export const HeaderBox = ({ children }) => {
  return (
    <Box bg="white" borderBottom="0.5px solid #DCDCE1" position="relative" zIndex="1000" h="54px">
      {children}
    </Box>
  )
}
